export const IconDropdown = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="6" viewBox="0 0 10 6" fill="none">
    <path d="M5 6L10 -9.91269e-08H0L5 6Z" fill="currentColor" />
  </svg>
);

export const IconSearch = ({ size = 20 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="11" cy="11" r="8" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);

export const IconSpin = () => (
  <svg
    className="animate-spin -ml-1 mr-3 h-10 w-10 text-red-300"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
  >
    <circle
      className="opacity-25"
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="4"
    ></circle>
    <path
      className="opacity-75"
      fill="currentColor"
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    ></path>
  </svg>
);

export const IconClose = ({ size = 32 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="#000000"
    viewBox="0 0 32 32"
    width={size}
    height={size}
  >
    <path d="M 7.21875 5.78125 L 5.78125 7.21875 L 14.5625 16 L 5.78125 24.78125 L 7.21875 26.21875 L 16 17.4375 L 24.78125 26.21875 L 26.21875 24.78125 L 17.4375 16 L 26.21875 7.21875 L 24.78125 5.78125 L 16 14.5625 Z" />
  </svg>
);

export const IconWhatsapp = ({ size = 32 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="#fff" aria-label="WhatsApp" viewBox="0 0 512 512">
    <path d="M308 273c-3-2-6-3-9 1l-12 16c-3 2-5 3-9 1-15-8-36-17-54-47-1-4 1-6 3-8l9-14c2-2 1-4 0-6l-12-29c-3-8-6-7-9-7h-8c-2 0-6 1-10 5-22 22-13 53 3 73 3 4 23 40 66 59 32 14 39 12 48 10 11-1 22-10 27-19 1-3 6-16 2-18" />
    <path d="M264 384c-41 0-72-22-72-22l-49 13 12-48s-20-31-20-70c0-72 59-132 132-132 68 0 126 53 126 127 0 72-58 131-129 132m-159 29l83-23a158 158 0 0 0 230-140c0-86-68-155-154-155a158 158 0 0 0-137 236" />
  </svg>
);

export const IconLocation = ({ size = 32, color }) => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width={size}
    height={size}
    viewBox="0 0 122.88 122.88"
    fill={color}
  >
    <g>
      <path d="M68.23,13.49c10.44,1.49,19.79,6.36,26.91,13.48c7.29,7.29,12.23,16.93,13.58,27.68h14.17v13.58h-14.39 c-1.62,10.13-6.42,19.2-13.36,26.13c-7.11,7.11-16.47,11.99-26.91,13.48v15.04H54.65v-15.04c-10.44-1.49-19.79-6.36-26.9-13.48 c-6.94-6.94-11.74-16-13.36-26.13H0V54.65h14.16c1.35-10.75,6.29-20.39,13.58-27.68c7.11-7.11,16.46-11.99,26.9-13.48V0h13.58 V13.49L68.23,13.49z M61.44,35.41c13.95,0,25.25,11.31,25.25,25.25c0,13.95-11.31,25.25-25.25,25.25 c-13.95,0-25.25-11.31-25.25-25.25C36.19,46.72,47.49,35.41,61.44,35.41L61.44,35.41z M89,33.11c-7.05-7.05-16.8-11.42-27.56-11.42 c-10.76,0-20.51,4.36-27.56,11.42c-7.05,7.05-11.42,16.8-11.42,27.56c0,10.76,4.36,20.51,11.42,27.56 c7.05,7.05,16.8,11.42,27.56,11.42c10.76,0,20.51-4.36,27.56-11.42c7.05-7.05,11.42-16.8,11.42-27.56 C100.41,49.9,96.05,40.16,89,33.11L89,33.11z" />
    </g>
  </svg>
);
export const IconMapLoading = ({ size, fill = 'red' }) => (
  <svg
    role="status"
    className="inline h-full w-full animate-spin mr-2 text-gray-200 dark:text-gray-600 fill-green-500 "
    viewBox="0 0 100 101"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
      fill="grey"
    />
    <path
      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
      fill="currentFill"
    />
  </svg>
);

export const IconSearchInputOrders = ({ size = 32 }) => (
  <svg
    className="search-icon fill-current"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    version="1.1"
    x="0px"
    y="0px"
    viewBox="0 0 56.966 56.966"
    style={{ enableBackground: 'new 0 0 56.966 56.966' }}
    xmlSpace="preserve"
    width="512px"
    height="512px"
  >
    <path d="M55.146,51.887L41.588,37.786c3.486-4.144,5.396-9.358,5.396-14.786c0-12.682-10.318-23-23-23s-23,10.318-23,23  s10.318,23,23,23c4.761,0,9.298-1.436,13.177-4.162l13.661,14.208c0.571,0.593,1.339,0.92,2.162,0.92  c0.779,0,1.518-0.297,2.079-0.837C56.255,54.982,56.293,53.08,55.146,51.887z M23.984,6c9.374,0,17,7.626,17,17s-7.626,17-17,17  s-17-7.626-17-17S14.61,6,23.984,6z" />
  </svg>
);

export const CheckMark = ({ color = 'red' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill={color}>
    <g data-name="Layer 2">
      <g data-name="checkmark-circle">
        <rect width="24" height="24" opacity="0" />
        <path d="M9.71 11.29a1 1 0 0 0-1.42 1.42l3 3A1 1 0 0 0 12 16a1 1 0 0 0 .72-.34l7-8a1 1 0 0 0-1.5-1.32L12 13.54z" />
        <path d="M21 11a1 1 0 0 0-1 1 8 8 0 0 1-8 8A8 8 0 0 1 6.33 6.36 7.93 7.93 0 0 1 12 4a8.79 8.79 0 0 1 1.9.22 1 1 0 1 0 .47-1.94A10.54 10.54 0 0 0 12 2a10 10 0 0 0-7 17.09A9.93 9.93 0 0 0 12 22a10 10 0 0 0 10-10 1 1 0 0 0-1-1z" />
      </g>
    </g>
  </svg>
);

export const CheckMarkOutLine = ({ color = 'green' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill={color}>
    <g data-name="Layer 2">
      <g data-name="checkmark">
        <rect width="24" height="24" opacity="0" />
        <path d="M9.86 18a1 1 0 0 1-.73-.32l-4.86-5.17a1 1 0 1 1 1.46-1.37l4.12 4.39 8.41-9.2a1 1 0 1 1 1.48 1.34l-9.14 10a1 1 0 0 1-.73.33z" />
      </g>
    </g>
  </svg>
);

export const Chevron = ({ color = 'green' }) => (
  <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" fill={color}>
    <path
      d="M18.7903 8.3871C19.0953 8.77939 19.0676 9.34662 18.7071 9.70711C18.3166 10.0976 17.6834 10.0976 17.2929 9.70711L12 4.41421L6.70711 9.70711L6.6129 9.79029C6.22061 10.0953 5.65338 10.0676 5.29289 9.70711C4.90237 9.31658 4.90237 8.68342 5.29289 8.29289L11.2929 2.29289L11.3871 2.2097C11.7794 1.90468 12.3466 1.93241 12.7071 2.29289L18.7071 8.29289L18.7903 8.3871ZM5.20971 15.6129C4.90468 15.2206 4.93241 14.6534 5.29289 14.2929C5.68342 13.9024 6.31658 13.9024 6.70711 14.2929L12 19.5858L17.2929 14.2929L17.3871 14.2097C17.7794 13.9047 18.3466 13.9324 18.7071 14.2929C19.0976 14.6834 19.0976 15.3166 18.7071 15.7071L12.7071 21.7071L12.6129 21.7903C12.2206 22.0953 11.6534 22.0676 11.2929 21.7071L5.29289 15.7071L5.20971 15.6129Z"
      fill={color}
    />
  </svg>
);

export const Start = ({ color = 'green' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill={color}>
    <g data-name="Layer 2">
      <g data-name="star">
        <rect width="24" height="24" transform="rotate(90 12 12)" opacity="0" />
        <path d="M17.56 21a1 1 0 0 1-.46-.11L12 18.22l-5.1 2.67a1 1 0 0 1-1.45-1.06l1-5.63-4.12-4a1 1 0 0 1-.25-1 1 1 0 0 1 .81-.68l5.7-.83 2.51-5.13a1 1 0 0 1 1.8 0l2.54 5.12 5.7.83a1 1 0 0 1 .81.68 1 1 0 0 1-.25 1l-4.12 4 1 5.63a1 1 0 0 1-.4 1 1 1 0 0 1-.62.18z" />
      </g>
    </g>
  </svg>
);

export const StartOutLine = ({ color = 'green' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill={color}>
    <g data-name="Layer 2">
      <g data-name="star">
        <rect width="24" height="24" transform="rotate(90 12 12)" opacity="0" />
        <path d="M17.56 21a1 1 0 0 1-.46-.11L12 18.22l-5.1 2.67a1 1 0 0 1-1.45-1.06l1-5.63-4.12-4a1 1 0 0 1-.25-1 1 1 0 0 1 .81-.68l5.7-.83 2.51-5.13a1 1 0 0 1 1.8 0l2.54 5.12 5.7.83a1 1 0 0 1 .81.68 1 1 0 0 1-.25 1l-4.12 4 1 5.63a1 1 0 0 1-.4 1 1 1 0 0 1-.62.18zM12 16.1a.92.92 0 0 1 .46.11l3.77 2-.72-4.21a1 1 0 0 1 .29-.89l3-2.93-4.2-.62a1 1 0 0 1-.71-.56L12 5.25 10.11 9a1 1 0 0 1-.75.54l-4.2.62 3 2.93a1 1 0 0 1 .29.89l-.72 4.16 3.77-2a.92.92 0 0 1 .5-.04z" />
      </g>
    </g>
  </svg>
);

export const CarOutLine = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white">
    <g data-name="Layer 2">
      <g data-name="car">
        <rect width="24" height="24" opacity="0" />
        <path d="M21.6 11.22L17 7.52V5a1.91 1.91 0 0 0-1.81-2H3.79A1.91 1.91 0 0 0 2 5v10a2 2 0 0 0 1.2 1.88 3 3 0 1 0 5.6.12h6.36a3 3 0 1 0 5.64 0h.2a1 1 0 0 0 1-1v-4a1 1 0 0 0-.4-.78zM20 12.48V15h-3v-4.92zM7 18a1 1 0 1 1-1-1 1 1 0 0 1 1 1zm5-3H4V5h11v10zm7 3a1 1 0 1 1-1-1 1 1 0 0 1 1 1z" />
      </g>
    </g>
  </svg>
);

export const ArrowBack = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="arrow-ios-back">
        <rect width="24" height="24" transform="rotate(90 12 12)" opacity="0" />
        <path d="M13.83 19a1 1 0 0 1-.78-.37l-4.83-6a1 1 0 0 1 0-1.27l5-6a1 1 0 0 1 1.54 1.28L10.29 12l4.32 5.36a1 1 0 0 1-.78 1.64z" />
      </g>
    </g>
  </svg>
);

export const ArrowNext = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <g data-name="Layer 2">
      <g data-name="arrow-ios-forward">
        <rect width="24" height="24" transform="rotate(-90 12 12)" opacity="0" />
        <path d="M10 19a1 1 0 0 1-.64-.23 1 1 0 0 1-.13-1.41L13.71 12 9.39 6.63a1 1 0 0 1 .15-1.41 1 1 0 0 1 1.46.15l4.83 6a1 1 0 0 1 0 1.27l-5 6A1 1 0 0 1 10 19z" />
      </g>
    </g>
  </svg>
);

export const Gift = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white">
    <g data-name="Layer 2">
      <g data-name="gift">
        <rect width="24" height="24" transform="rotate(180 12 12)" opacity="0" />
        <path d="M19.2 7h-.39A3 3 0 0 0 19 6a3.08 3.08 0 0 0-3.14-3A4.46 4.46 0 0 0 12 5.4 4.46 4.46 0 0 0 8.14 3 3.08 3.08 0 0 0 5 6a3 3 0 0 0 .19 1H4.8A2 2 0 0 0 3 9.2v3.6A2.08 2.08 0 0 0 4.5 15v4.37A1.75 1.75 0 0 0 6.31 21h11.38a1.75 1.75 0 0 0 1.81-1.67V15a2.08 2.08 0 0 0 1.5-2.2V9.2A2 2 0 0 0 19.2 7zM19 9.2v3.6a.56.56 0 0 1 0 .2h-6V9h6a.56.56 0 0 1 0 .2zM15.86 5A1.08 1.08 0 0 1 17 6a1.08 1.08 0 0 1-1.14 1H13.4a2.93 2.93 0 0 1 2.46-2zM7 6a1.08 1.08 0 0 1 1.14-1 2.93 2.93 0 0 1 2.45 2H8.14A1.08 1.08 0 0 1 7 6zM5 9.2A.56.56 0 0 1 5 9h6v4H5a.56.56 0 0 1 0-.2zM6.5 15H11v4H6.5zm6.5 4v-4h4.5v4z" />
      </g>
    </g>
  </svg>
);

export const Sync = () => (
  <svg width="20" height="20" viewBox="0 0 46 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M33.404 11.1569C30.569 8.57106 26.888 7.15103 22.982 7.1598C15.953 7.16856 9.887 11.8582 8.213 18.371C8.087 18.8444 7.655 19.1775 7.16 19.1775H1.958C1.274 19.1775 0.761 18.5726 0.887 17.924C2.849 7.76462 12.002 0.0859375 23 0.0859375C29.03 0.0859375 34.502 2.3913 38.543 6.15175L41.783 2.99613C43.151 1.66375 45.5 2.61044 45.5 4.49505V16.3374C45.5 17.512 44.528 18.4587 43.322 18.4587H31.163C29.219 18.4587 28.256 16.1709 29.624 14.8385L33.404 11.1569ZM2.678 25.5325H14.837C16.781 25.5325 17.744 27.8204 16.376 29.1528L12.587 32.8431C15.422 35.4289 19.103 36.849 23.009 36.8402C30.029 36.8314 36.104 32.1418 37.778 25.629C37.904 25.1556 38.336 24.8225 38.831 24.8225H44.033C44.717 24.8225 45.23 25.4274 45.104 26.076C43.151 36.2354 33.998 43.9141 23 43.9141C16.97 43.9141 11.498 41.6087 7.457 37.8483L4.217 41.0039C2.849 42.3363 0.5 41.3896 0.5 39.505V27.6538C0.5 26.488 1.472 25.5325 2.678 25.5325Z"
      fill="#2FB13C"
    />
  </svg>
);

export const NotSync = () => (
  <svg width="20" height="20" viewBox="0 0 46 52" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.94926 5.04152C5.14886 3.91648 5.41203 2.3556 6.53707 1.55519V1.55519C7.66211 0.754789 9.22299 1.01796 10.0234 2.143L41.9072 46.9585C42.7076 48.0835 42.4444 49.6444 41.3193 50.4448V50.4448C40.1943 51.2452 38.6334 50.982 37.833 49.857L5.94926 5.04152Z"
      fill="#BBBBBB"
    />
    <path
      d="M33.404 15.0754C30.569 12.4896 26.888 11.0695 22.982 11.0783C15.953 11.0871 9.887 15.7767 8.213 22.2896C8.087 22.7629 7.655 23.096 7.16 23.096H1.958C1.274 23.096 0.761 22.4912 0.887 21.8425C2.849 11.6831 12.002 4.00446 23 4.00446C29.03 4.00446 34.502 6.30981 38.543 10.0703L41.783 6.91464C43.151 5.58227 45.5 6.52896 45.5 8.41357V20.2559C45.5 21.4305 44.528 22.3772 43.322 22.3772H31.163C29.219 22.3772 28.256 20.0894 29.624 18.757L33.404 15.0754ZM2.678 29.4511H14.837C16.781 29.4511 17.744 31.7389 16.376 33.0713L12.587 36.7616C15.422 39.3475 19.103 40.7675 23.009 40.7587C30.029 40.75 36.104 36.0603 37.778 29.5475C37.904 29.0741 38.336 28.7411 38.831 28.7411H44.033C44.717 28.7411 45.23 29.3459 45.104 29.9945C43.151 40.1539 33.998 47.8326 23 47.8326C16.97 47.8326 11.498 45.5272 7.457 41.7668L4.217 44.9224C2.849 46.2548 0.5 45.3081 0.5 43.4235V31.5723C0.5 30.4065 1.472 29.4511 2.678 29.4511Z"
      fill="#BBBBBB"
    />
  </svg>
);

export const SpinLoading = () => {
  return (
    <svg
      aria-hidden="true"
      role="status"
      className="w-6 h-6 text-gray-200 animate-spin dark:text-gray-600"
      viewBox="0 0 100 101"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
        fill="currentColor"
      />
      <path
        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
        fill="#1C64F2"
      />
    </svg>
  );
};
export const ArrowDropIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="ionicon"
    viewBox="0 0 512 512"
    width={16}
    height={16}
  >
    <path
      fill="none"
      stroke="grey"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="48"
      d="M184 112l144 144-144 144"
    />
  </svg>
);

export const DropIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="ionicon"
    viewBox="0 0 512 512"
    width={16}
    height={16}
  >
    <path
      fill="none"
      stroke="grey"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="48"
      d="M112 328l144-144 144 144"
    />
  </svg>
);

export const CloseIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="ionicon"
    viewBox="0 0 512 512"
    width={32}
    height={32}
  >
    <path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="32"
      d="M368 368L144 144M368 144L144 368"
    />
  </svg>
);

export const OrderIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="ionicon"
    viewBox="0 0 512 512"
    width={20}
    height={20}
  >
    <path
      d="M416 221.25V416a48 48 0 01-48 48H144a48 48 0 01-48-48V96a48 48 0 0148-48h98.75a32 32 0 0122.62 9.37l141.26 141.26a32 32 0 019.37 22.62z"
      fill="none"
      stroke="currentColor"
      stroke-linejoin="round"
      stroke-width="32"
    />
    <path
      d="M256 56v120a32 32 0 0032 32h120M176 288h160M176 368h160"
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="32"
    />
  </svg>
);

export const DriverIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="ionicon"
    viewBox="0 0 512 512"
    width={20}
    height={20}
  >
    <path
      d="M344 144c-3.92 52.87-44 96-88 96s-84.15-43.12-88-96c-4-55 35-96 88-96s92 42 88 96z"
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="32"
    />
    <path
      d="M256 304c-87 0-175.3 48-191.64 138.6C62.39 453.52 68.57 464 80 464h352c11.44 0 17.62-10.48 15.65-21.4C431.3 352 343 304 256 304z"
      fill="none"
      stroke="currentColor"
      stroke-miterlimit="10"
      stroke-width="32"
    />
  </svg>
);

export const LogIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="ionicon"
    viewBox="0 0 512 512"
    width={20}
    height={20}
  >
    <rect
      x="96"
      y="48"
      width="320"
      height="416"
      rx="48"
      ry="48"
      fill="none"
      stroke="currentColor"
      stroke-linejoin="round"
      stroke-width="32"
    />
    <path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="32"
      d="M176 128h160M176 208h160M176 288h80"
    />
  </svg>
);
export const DeliveryCompanyIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="ionicon"
    viewBox="0 0 512 512"
    width={20}
    height={20}
  >
    <path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="32"
      d="M176 416v64M80 32h192a32 32 0 0132 32v412a4 4 0 01-4 4H48h0V64a32 32 0 0132-32zM320 192h112a32 32 0 0132 32v256h0-160 0V208a16 16 0 0116-16z"
    />
    <path d="M98.08 431.87a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zM98.08 351.87a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zM98.08 271.87a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zM98.08 191.87a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zM98.08 111.87a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zM178.08 351.87a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zM178.08 271.87a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zM178.08 191.87a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zM178.08 111.87a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zM258.08 431.87a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zM258.08 351.87a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zM258.08 271.87a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79z" />
    <ellipse cx="256" cy="176" rx="15.95" ry="16.03" transform="rotate(-45 255.99 175.996)" />
    <path d="M258.08 111.87a16 16 0 1113.79-13.79 16 16 0 01-13.79 13.79zM400 400a16 16 0 1016 16 16 16 0 00-16-16zM400 320a16 16 0 1016 16 16 16 0 00-16-16zM400 240a16 16 0 1016 16 16 16 0 00-16-16zM336 400a16 16 0 1016 16 16 16 0 00-16-16zM336 320a16 16 0 1016 16 16 16 0 00-16-16zM336 240a16 16 0 1016 16 16 16 0 00-16-16z" />
  </svg>
);

export const AnalyticIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="ionicon"
    viewBox="0 0 512 512"
    width={20}
    height={20}
  >
    <path
      d="M32 32v432a16 16 0 0016 16h432"
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="32"
    />
    <rect
      x="96"
      y="224"
      width="80"
      height="192"
      rx="20"
      ry="20"
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="32"
    />
    <rect
      x="240"
      y="176"
      width="80"
      height="240"
      rx="20"
      ry="20"
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="32"
    />
    <rect
      x="383.64"
      y="112"
      width="80"
      height="304"
      rx="20"
      ry="20"
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="32"
    />
  </svg>
);

export const LogOutIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="ionicon"
    viewBox="0 0 512 512"
    width={20}
    height={20}
  >
    <path
      d="M320 176v-40a40 40 0 00-40-40H88a40 40 0 00-40 40v240a40 40 0 0040 40h192a40 40 0 0040-40v-40M384 176l80 80-80 80M191 256h273"
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="32"
    />
  </svg>
);

export const OpsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="ionicon"
    viewBox="0 0 512 512"
    width={20}
    height={20}
  >
    <rect
      x="96"
      y="32"
      width="320"
      height="448"
      rx="48"
      fill="none"
      stroke="currentColor"
      stroke-linejoin="round"
      stroke-width="32"
    />
    <path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="32"
      d="M208 80h96"
    />
    <path d="M333.48 284.51A39.65 39.65 0 00304 272c-11.6 0-22.09 4.41-29.54 12.43s-11.2 19.12-10.34 31C265.83 338.91 283.72 358 304 358s38.14-19.09 39.87-42.55c.88-11.78-2.82-22.77-10.39-30.94zM371.69 448H236.31a12.05 12.05 0 01-9.31-4.17 13 13 0 01-2.76-10.92c3.25-17.56 13.38-32.31 29.3-42.66C267.68 381.06 285.6 376 304 376s36.32 5.06 50.46 14.25c15.92 10.35 26.05 25.1 29.3 42.66a13 13 0 01-2.76 10.92 12.05 12.05 0 01-9.31 4.17z" />
  </svg>
);
export const RecoveryIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="ionicon"
    viewBox="0 0 512 512"
    width={20}
    height={20}
  >
    <path
      d="M416 221.25V416a48 48 0 01-48 48H144a48 48 0 01-48-48V96a48 48 0 0148-48h98.75a32 32 0 0122.62 9.37l141.26 141.26a32 32 0 019.37 22.62z"
      fill="none"
      stroke="currentColor"
      stroke-linejoin="round"
      stroke-width="32"
    />
    <path
      d="M256 56v120a32 32 0 0032 32h120M176 288h160M176 368h160"
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="32"
    />
  </svg>
);

export const SettingIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="ionicon"
    viewBox="0 0 512 512"
    width={20}
    height={20}
  >
    <path
      d="M262.29 192.31a64 64 0 1057.4 57.4 64.13 64.13 0 00-57.4-57.4zM416.39 256a154.34 154.34 0 01-1.53 20.79l45.21 35.46a10.81 10.81 0 012.45 13.75l-42.77 74a10.81 10.81 0 01-13.14 4.59l-44.9-18.08a16.11 16.11 0 00-15.17 1.75A164.48 164.48 0 01325 400.8a15.94 15.94 0 00-8.82 12.14l-6.73 47.89a11.08 11.08 0 01-10.68 9.17h-85.54a11.11 11.11 0 01-10.69-8.87l-6.72-47.82a16.07 16.07 0 00-9-12.22 155.3 155.3 0 01-21.46-12.57 16 16 0 00-15.11-1.71l-44.89 18.07a10.81 10.81 0 01-13.14-4.58l-42.77-74a10.8 10.8 0 012.45-13.75l38.21-30a16.05 16.05 0 006-14.08c-.36-4.17-.58-8.33-.58-12.5s.21-8.27.58-12.35a16 16 0 00-6.07-13.94l-38.19-30A10.81 10.81 0 0149.48 186l42.77-74a10.81 10.81 0 0113.14-4.59l44.9 18.08a16.11 16.11 0 0015.17-1.75A164.48 164.48 0 01187 111.2a15.94 15.94 0 008.82-12.14l6.73-47.89A11.08 11.08 0 01213.23 42h85.54a11.11 11.11 0 0110.69 8.87l6.72 47.82a16.07 16.07 0 009 12.22 155.3 155.3 0 0121.46 12.57 16 16 0 0015.11 1.71l44.89-18.07a10.81 10.81 0 0113.14 4.58l42.77 74a10.8 10.8 0 01-2.45 13.75l-38.21 30a16.05 16.05 0 00-6.05 14.08c.33 4.14.55 8.3.55 12.47z"
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="32"
    />
  </svg>
);

export const RattingIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="ionicon"
    viewBox="0 0 512 512"
    width={20}
    height={20}
  >
    <path
      d="M480 208H308L256 48l-52 160H32l140 96-54 160 138-100 138 100-54-160z"
      fill="none"
      stroke="currentColor"
      stroke-linejoin="round"
      stroke-width="32"
    />
  </svg>
);
export const OtpIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="ionicon"
    viewBox="0 0 512 512"
    width={20}
    height={20}
  >
    <path
      d="M431 320.6c-1-3.6 1.2-8.6 3.3-12.2a33.68 33.68 0 012.1-3.1A162 162 0 00464 215c.3-92.2-77.5-167-173.7-167-83.9 0-153.9 57.1-170.3 132.9a160.7 160.7 0 00-3.7 34.2c0 92.3 74.8 169.1 171 169.1 15.3 0 35.9-4.6 47.2-7.7s22.5-7.2 25.4-8.3a26.44 26.44 0 019.3-1.7 26 26 0 0110.1 2l56.7 20.1a13.52 13.52 0 003.9 1 8 8 0 008-8 12.85 12.85 0 00-.5-2.7z"
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-miterlimit="10"
      stroke-width="32"
    />
    <path
      d="M66.46 232a146.23 146.23 0 006.39 152.67c2.31 3.49 3.61 6.19 3.21 8s-11.93 61.87-11.93 61.87a8 8 0 002.71 7.68A8.17 8.17 0 0072 464a7.26 7.26 0 002.91-.6l56.21-22a15.7 15.7 0 0112 .2c18.94 7.38 39.88 12 60.83 12A159.21 159.21 0 00284 432.11"
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-miterlimit="10"
      stroke-width="32"
    />
  </svg>
);

export const PricingIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="ionicon"
    viewBox="0 0 512 512"
    width={20}
    height={20}
  >
    <path
      d="M403.29 32H280.36a14.46 14.46 0 00-10.2 4.2L24.4 281.9a28.85 28.85 0 000 40.7l117 117a28.86 28.86 0 0040.71 0L427.8 194a14.46 14.46 0 004.2-10.2v-123A28.66 28.66 0 00403.29 32z"
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="32"
    />
    <path d="M352 144a32 32 0 1132-32 32 32 0 01-32 32z" />
    <path
      d="M230 480l262-262a13.81 13.81 0 004-10V80"
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="32"
    />
  </svg>
);

export const MenuIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="ionicon"
    viewBox="0 0 512 512"
    width={40}
    height={40}
  >
    <path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-miterlimit="10"
      stroke-width="32"
      d="M80 160h352M80 256h352M80 352h352"
    />
  </svg>
);

export const PlusIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="ionicon"
    viewBox="0 0 512 512"
    width={14}
    height={14}
  >
    <path
      d="M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
      fill="none"
      stroke="currentColor"
      stroke-miterlimit="10"
      stroke-width="32"
    />
    <path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="32"
      d="M256 176v160M336 256H176"
    />
  </svg>
);

export const Subtraction = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="ionicon"
    viewBox="0 0 512 512"
    width={14}
    height={14}
  >
    <path
      d="M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
      fill="none"
      stroke="currentColor"
      stroke-miterlimit="10"
      stroke-width="32"
    />
    <path
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="32"
      d="M336 256H176"
    />
  </svg>
);

export const ItemInfoIcon =
  'M30.9090909,7.27272727 L1.81818182,7.27272727 C0.814545455,7.27272727 0,8.08727273 0,9.09090909 L0,41.8181818 C0,42.8218182 0.814545455,43.6363636 1.81818182,43.6363636 L30.9090909,43.6363636 C31.9127273,43.6363636 32.7272727,42.8218182 32.7272727,41.8181818 L32.7272727,9.09090909 C32.7272727,8.08727273 31.9127273,7.27272727 30.9090909,7.27272727 Z M18.1818182,34.5454545 L7.27272727,34.5454545 L7.27272727,30.9090909 L18.1818182,30.9090909 L18.1818182,34.5454545 Z M25.4545455,27.2727273 L7.27272727,27.2727273 L7.27272727,23.6363636 L25.4545455,23.6363636 L25.4545455,27.2727273 Z M25.4545455,20 L7.27272727,20 L7.27272727,16.3636364 L25.4545455,16.3636364 L25.4545455,20 Z';

export const IconLoadingMap = () => (
  <svg
    aria-hidden="true"
    role="status"
    className="w-6 h-6 text-gray-200 animate-spin dark:text-gray-600"
    viewBox="0 0 100 101"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
      fill="currentColor"
    />
    <path
      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
      fill="#1C64F2"
    />
  </svg>
);

export const IconRating = ({ color = '#ffffff' }) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="32" height="32" rx="4" />
    <g clipPath="url(#clip0_1741_4301)">
      <path
        d="M8.54946 13.5159L13.6457 12.7494L15.9239 7.96984C15.9861 7.83898 16.0885 7.73304 16.2149 7.66865C16.5321 7.50663 16.9175 7.64165 17.076 7.96984L19.3542 12.7494L24.4505 13.5159C24.591 13.5366 24.7194 13.6052 24.8178 13.709C24.9367 13.8355 25.0022 14.0057 24.9999 14.1821C24.9977 14.3585 24.9278 14.5268 24.8057 14.65L21.1185 18.3702L21.9896 23.6233C22.0101 23.7455 21.997 23.8712 21.9519 23.9861C21.9068 24.101 21.8316 24.2005 21.7346 24.2734C21.6376 24.3463 21.5229 24.3896 21.4033 24.3984C21.2838 24.4072 21.1643 24.3812 21.0583 24.3233L16.5 21.8432L11.9416 24.3233C11.8172 24.3919 11.6727 24.4147 11.5342 24.3898C11.1849 24.3275 10.9501 23.9847 11.0103 23.6233L11.8814 18.3702L8.19419 14.65C8.09382 14.5482 8.02759 14.4153 8.00751 14.2699C7.95332 13.9064 8.1982 13.5699 8.54946 13.5159Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_1741_4301">
        <rect width="17" height="28" fill="white" transform="translate(8 2)" />
      </clipPath>
    </defs>
  </svg>
);

export const IconTiktok = () => (
  <svg width="24px" height="24px" viewBox="0 0 250 250" xmlns="http://www.w3.org/2000/svg">
    <g clip-rule="evenodd" fill-rule="evenodd">
      <path
        d="M25 0h200c13.808 0 25 11.192 25 25v200c0 13.808-11.192 25-25 25H25c-13.808 0-25-11.192-25-25V25C0 11.192 11.192 0 25 0z"
        fill="#010101"
      />

      <path
        d="M156.98 230c7.607 0 13.774-6.117 13.774-13.662s-6.167-13.663-13.774-13.663h-2.075c7.607 0 13.774 6.118 13.774 13.663S162.512 230 154.905 230z"
        fill="#ee1d51"
      />

      <path
        d="M154.717 202.675h-2.075c-7.607 0-13.775 6.118-13.775 13.663S145.035 230 152.642 230h2.075c-7.608 0-13.775-6.117-13.775-13.662s6.167-13.663 13.775-13.663z"
        fill="#66c8cf"
      />

      <ellipse cx="154.811" cy="216.338" fill="#010101" rx="6.699" ry="6.643" />

      <path
        d="M50 196.5v6.925h8.112v26.388h8.115v-26.201h6.603l2.264-7.112zm66.415 0v6.925h8.112v26.388h8.115v-26.201h6.603l2.264-7.112zm-39.81 3.93c0-2.17 1.771-3.93 3.959-3.93 2.19 0 3.963 1.76 3.963 3.93s-1.772 3.93-3.963 3.93c-2.188-.001-3.959-1.76-3.959-3.93zm0 6.738h7.922v22.645h-7.922zM87.924 196.5v33.313h7.925v-8.608l2.453-2.248L106.037 230h8.49l-11.133-16.095 10-9.733h-9.622l-7.923 7.86V196.5zm85.47 0v33.313h7.926v-8.608l2.452-2.248L191.509 230H200l-11.133-16.095 10-9.733h-9.622l-7.925 7.86V196.5z"
        fill="#ffffff"
      />

      <path
        d="M161.167 81.186c10.944 7.819 24.352 12.42 38.832 12.42V65.755a39.26 39.26 0 0 1-8.155-.853v21.923c-14.479 0-27.885-4.601-38.832-12.42v56.835c0 28.432-23.06 51.479-51.505 51.479-10.613 0-20.478-3.207-28.673-8.707C82.187 183.57 95.23 189.5 109.66 189.5c28.447 0 51.508-23.047 51.508-51.48V81.186zm10.06-28.098c-5.593-6.107-9.265-14-10.06-22.726V26.78h-7.728c1.945 11.09 8.58 20.565 17.788 26.308zm-80.402 99.107a23.445 23.445 0 0 1-4.806-14.256c0-13.004 10.548-23.547 23.561-23.547a23.6 23.6 0 0 1 7.147 1.103V87.022a51.97 51.97 0 0 0-8.152-.469v22.162a23.619 23.619 0 0 0-7.15-1.103c-13.013 0-23.56 10.543-23.56 23.548 0 9.195 5.272 17.157 12.96 21.035z"
        fill="#ee1d52"
      />

      <path
        d="M153.012 74.405c10.947 7.819 24.353 12.42 38.832 12.42V64.902c-8.082-1.72-15.237-5.942-20.617-11.814-9.208-5.743-15.843-15.218-17.788-26.308H133.14v111.239c-.046 12.968-10.576 23.468-23.561 23.468-7.652 0-14.45-3.645-18.755-9.292-7.688-3.878-12.96-11.84-12.96-21.035 0-13.005 10.547-23.548 23.56-23.548 2.493 0 4.896.388 7.15 1.103V86.553c-27.945.577-50.42 23.399-50.42 51.467 0 14.011 5.597 26.713 14.68 35.993 8.195 5.5 18.06 8.707 28.673 8.707 28.445 0 51.505-23.048 51.505-51.479z"
        fill="#ffffff"
      />

      <path
        d="M191.844 64.902v-5.928a38.84 38.84 0 0 1-20.617-5.887 38.948 38.948 0 0 0 20.617 11.815zM153.439 26.78a39.524 39.524 0 0 1-.427-3.198V20h-28.028v111.24c-.045 12.967-10.574 23.467-23.56 23.467-3.813 0-7.412-.904-10.6-2.512 4.305 5.647 11.103 9.292 18.755 9.292 12.984 0 23.515-10.5 23.561-23.468V26.78zm-44.864 59.773v-6.311a51.97 51.97 0 0 0-7.067-.479C73.06 79.763 50 102.811 50 131.24c0 17.824 9.063 33.532 22.835 42.772-9.083-9.28-14.68-21.982-14.68-35.993 0-28.067 22.474-50.889 50.42-51.466z"
        fill="#69c9d0"
      />

      <path
        d="M154.904 230c7.607 0 13.775-6.117 13.775-13.662s-6.168-13.663-13.775-13.663h-.188c-7.607 0-13.774 6.118-13.774 13.663S147.109 230 154.716 230zm-6.792-13.662c0-3.67 3-6.643 6.7-6.643 3.697 0 6.697 2.973 6.697 6.643s-3 6.645-6.697 6.645c-3.7-.001-6.7-2.975-6.7-6.645z"
        fill="#ffffff"
      />
    </g>
  </svg>
);

export const IconFacebook = () => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
  >
    <path
      fill="#1877F2"
      d="M15 8a7 7 0 00-7-7 7 7 0 00-1.094 13.915v-4.892H5.13V8h1.777V6.458c0-1.754 1.045-2.724 2.644-2.724.766 0 1.567.137 1.567.137v1.723h-.883c-.87 0-1.14.54-1.14 1.093V8h1.941l-.31 2.023H9.094v4.892A7.001 7.001 0 0015 8z"
    />
    <path
      fill="#ffffff"
      d="M10.725 10.023L11.035 8H9.094V6.687c0-.553.27-1.093 1.14-1.093h.883V3.87s-.801-.137-1.567-.137c-1.6 0-2.644.97-2.644 2.724V8H5.13v2.023h1.777v4.892a7.037 7.037 0 002.188 0v-4.892h1.63z"
    />
  </svg>
);

export const IconSnapchat = () => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="16" cy="16" r="14" fill="#FFFA37" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M21.0255 8.18551C20.0601 6.96879 18.4673 6 16.0118 6C13.9091 6.02071 9.70378 7.18445 9.70378 11.6738C9.70378 12.3294 9.75568 13.2075 9.80103 13.8541C9.74758 13.8386 9.68188 13.8095 9.57775 13.7596L9.56328 13.7527C9.37915 13.6643 9.09918 13.5298 8.7098 13.5298C8.31645 13.5298 7.93611 13.6839 7.65375 13.9124C7.37309 14.1394 7.13333 14.4885 7.13333 14.9105C7.13333 15.4384 7.43041 15.7888 7.77778 16.0135C8.08632 16.2131 8.47538 16.3406 8.78337 16.4415L8.81382 16.4514C9.14349 16.5596 9.3851 16.642 9.55169 16.7458C9.68136 16.8267 9.70104 16.8778 9.70348 16.9264C9.70179 16.9333 9.69782 16.9482 9.68919 16.9724C9.67141 17.0224 9.64184 17.0899 9.59862 17.1743C9.5124 17.3427 9.38667 17.5498 9.23711 17.7706C8.93539 18.2161 8.56717 18.673 8.29212 18.9376C8.02082 19.1986 7.57562 19.5229 7.11016 19.7811C6.87933 19.9091 6.6536 20.0152 6.45167 20.0881C6.24322 20.1633 6.09047 20.192 5.99608 20.192C5.92136 20.192 5.85669 20.2073 5.82847 20.2144C5.7888 20.2243 5.74774 20.2374 5.70713 20.2527C5.62657 20.2829 5.53056 20.3283 5.43546 20.3923C5.25377 20.5146 5 20.7612 5 21.1502C5 21.3532 5.04766 21.5251 5.13005 21.6742C5.20217 21.8047 5.29487 21.9038 5.34823 21.9608L5.35615 21.9692L5.37091 21.9851C5.66435 22.3008 6.15008 22.5205 6.62162 22.6712C7.02679 22.8007 7.4798 22.8972 7.92122 22.9551C7.92745 22.9836 7.93397 23.0142 7.9411 23.0478L7.9434 23.0587C7.97119 23.1897 8.008 23.3633 8.06221 23.5234C8.11336 23.6744 8.20599 23.8977 8.39564 24.0568C8.63717 24.2593 8.95308 24.2798 9.1592 24.279C9.38047 24.2781 9.63881 24.2469 9.88394 24.2174L9.90481 24.2149C10.2497 24.1733 10.6106 24.1304 10.9843 24.1304C11.6663 24.1304 12.1035 24.4153 12.7894 24.8837L12.794 24.8869C13.0316 25.0492 13.2976 25.2308 13.6 25.4095C14.6122 26.0076 15.4346 26.0025 15.9007 25.9995C15.9315 25.9993 15.9606 25.9992 15.9882 25.9992C16.0158 25.9992 16.0452 25.9993 16.0761 25.9995C16.543 26.0025 17.3873 26.0079 18.4 25.4095C18.7024 25.2308 18.9684 25.0492 19.2059 24.8869L19.2106 24.8837C19.8965 24.4153 20.3337 24.1304 21.0157 24.1304C21.3894 24.1304 21.7503 24.1733 22.0952 24.2149L22.1161 24.2174C22.3612 24.2469 22.6195 24.2781 22.8408 24.279C23.0469 24.2798 23.3628 24.2593 23.6044 24.0568C23.794 23.8977 23.8866 23.6744 23.9378 23.5234C23.992 23.3634 24.0288 23.1898 24.0566 23.0587L24.0589 23.0478C24.066 23.0142 24.0725 22.9836 24.0788 22.9551C24.5202 22.8972 24.9732 22.8007 25.3784 22.6712C25.8499 22.5205 26.3357 22.3007 26.6291 21.985L26.6439 21.9692L26.6517 21.9608C26.7051 21.9038 26.7978 21.8047 26.8699 21.6742C26.9523 21.5251 27 21.3532 27 21.1502C27 20.7612 26.7462 20.5146 26.5645 20.3923C26.4694 20.3283 26.3734 20.2829 26.2929 20.2527C26.2523 20.2374 26.2112 20.2243 26.1715 20.2144C26.1433 20.2073 26.0786 20.192 26.0039 20.192C25.9095 20.192 25.7568 20.1633 25.5483 20.0881C25.3464 20.0152 25.1207 19.9091 24.8898 19.7811C24.4244 19.5229 23.9792 19.1986 23.7079 18.9376C23.4328 18.673 23.0646 18.2161 22.7629 17.7706C22.6133 17.5498 22.4876 17.3427 22.4014 17.1743C22.3582 17.0899 22.3286 17.0224 22.3108 16.9724C22.3022 16.9482 22.2982 16.9333 22.2965 16.9264C22.299 16.8778 22.3186 16.8267 22.4483 16.7458C22.6149 16.642 22.8565 16.5596 23.1862 16.4514L23.2166 16.4415C23.5246 16.3406 23.9137 16.2131 24.2222 16.0135C24.5696 15.7888 24.8667 15.4384 24.8667 14.9105C24.8667 14.4885 24.6269 14.1394 24.3462 13.9124C24.0639 13.6839 23.6835 13.5298 23.2902 13.5298C22.9008 13.5298 22.6209 13.6643 22.4367 13.7527L22.4223 13.7596C22.3181 13.8095 22.2524 13.8386 22.199 13.8541C22.2443 13.2075 22.2962 12.3294 22.2962 11.6738C22.2962 10.7837 21.9726 9.37904 21.0255 8.18551ZM11.7832 8.77274C10.9822 9.77549 10.7077 10.9662 10.7077 11.6738C10.7077 12.3299 10.7633 13.2413 10.8102 13.8949C10.8258 14.1119 10.7813 14.365 10.5917 14.5658C10.3998 14.7691 10.1388 14.8351 9.90561 14.8351C9.56889 14.8351 9.3128 14.7119 9.14898 14.6331L9.12996 14.624C8.94718 14.5363 8.85108 14.4956 8.7098 14.4956C8.58128 14.4956 8.42437 14.5508 8.29994 14.6515C8.17382 14.7535 8.13725 14.8534 8.13725 14.9105C8.13725 15.0269 8.18018 15.1101 8.33794 15.2121C8.52427 15.3326 8.78976 15.4232 9.13779 15.5374L9.16809 15.5473C9.45712 15.642 9.81511 15.7593 10.0976 15.9354C10.4147 16.133 10.7077 16.4507 10.7077 16.9401C10.7077 17.0684 10.6722 17.1919 10.6389 17.2854C10.6028 17.3869 10.554 17.4941 10.4992 17.601C10.3896 17.8152 10.2413 18.0571 10.0783 18.2978C9.75483 18.7754 9.3437 19.2918 9.002 19.6205C8.65655 19.9528 8.13703 20.3263 7.61159 20.6178C7.34696 20.7645 7.07068 20.8961 6.80428 20.9923C6.56581 21.0783 6.3088 21.1457 6.06224 21.1563C6.0561 21.1589 6.04931 21.162 6.0422 21.1655C6.03083 21.1713 6.0202 21.1774 6.01092 21.1837L6.00618 21.187C6.00711 21.1936 6.00817 21.1985 6.00906 21.202C6.01103 21.2097 6.01337 21.2152 6.01652 21.2209C6.02619 21.2384 6.04143 21.2579 6.1031 21.324L6.11928 21.3413C6.23038 21.4609 6.50416 21.616 6.93815 21.7547C7.35148 21.8868 7.84023 21.9822 8.30201 22.026C8.53305 22.0479 8.66621 22.1923 8.72257 22.2701C8.78059 22.3501 8.81377 22.4347 8.83316 22.4908C8.87067 22.5994 8.899 22.7332 8.92135 22.8387L8.92474 22.8547C8.95525 22.9985 8.98194 23.1215 9.01675 23.2242C9.02905 23.2606 9.0404 23.2882 9.05017 23.3085C9.0722 23.3111 9.10599 23.3135 9.15493 23.3133C9.36726 23.3124 9.57984 23.2808 9.79022 23.2554C10.1268 23.2148 10.5433 23.1646 10.9843 23.1646C12.0071 23.1646 12.682 23.6258 13.334 24.0713L13.3706 24.0963C13.6118 24.261 13.8536 24.4259 14.1255 24.5866C14.8917 25.0394 15.4747 25.0361 15.9007 25.0337C15.9306 25.0336 15.9598 25.0334 15.9882 25.0334C16.0164 25.0334 16.0454 25.0336 16.0753 25.0337C16.5059 25.036 17.1085 25.0393 17.8745 24.5866C18.1464 24.4259 18.3882 24.261 18.6294 24.0963L18.666 24.0713C19.318 23.6258 19.9929 23.1646 21.0157 23.1646C21.4567 23.1646 21.8732 23.2148 22.2098 23.2554L22.2199 23.2566C22.4921 23.2894 22.6913 23.3126 22.8451 23.3133C22.894 23.3135 22.9278 23.3111 22.9498 23.3085C22.9596 23.2882 22.9709 23.2606 22.9833 23.2242C23.0181 23.1215 23.0447 22.9985 23.0753 22.8547L23.0787 22.8387C23.101 22.7331 23.1293 22.5994 23.1668 22.4908C23.1862 22.4347 23.2194 22.3501 23.2774 22.2701C23.3338 22.1923 23.467 22.0479 23.698 22.026C24.1598 21.9822 24.6485 21.8868 25.0618 21.7547C25.4958 21.616 25.7696 21.4609 25.8807 21.3414L25.8969 21.324C25.9585 21.2579 25.9738 21.2384 25.9835 21.2209C25.9866 21.2152 25.989 21.2097 25.9909 21.202C25.9918 21.1985 25.9929 21.1936 25.9938 21.187L25.9891 21.1837C25.9798 21.1774 25.9692 21.1713 25.9578 21.1655C25.9507 21.1619 25.9439 21.1589 25.9378 21.1563C25.6912 21.1457 25.4342 21.0783 25.1957 20.9923C24.9293 20.8961 24.653 20.7645 24.3884 20.6178C23.863 20.3263 23.3435 19.9528 22.998 19.6205C22.6563 19.2918 22.2452 18.7754 21.9217 18.2978C21.7587 18.0571 21.6104 17.8152 21.5008 17.601C21.446 17.4941 21.3972 17.3869 21.3611 17.2854C21.3278 17.1919 21.2923 17.0684 21.2923 16.9401C21.2923 16.4507 21.5853 16.133 21.9024 15.9354C22.1849 15.7593 22.5429 15.642 22.8319 15.5473L22.8622 15.5374C23.2102 15.4232 23.4757 15.3326 23.6621 15.2121C23.8198 15.1101 23.8627 15.0269 23.8627 14.9105C23.8627 14.8534 23.8262 14.7535 23.7001 14.6515C23.5756 14.5508 23.4187 14.4956 23.2902 14.4956C23.1489 14.4956 23.0528 14.5363 22.87 14.624L22.851 14.6331C22.6872 14.7119 22.4311 14.8351 22.0944 14.8351C21.8612 14.8351 21.6002 14.7691 21.4083 14.5658C21.2187 14.365 21.1742 14.1119 21.1898 13.8949C21.2367 13.2413 21.2923 12.3299 21.2923 11.6738C21.2923 10.9643 21.0227 9.77352 20.2275 8.77149C19.4508 7.79264 18.1523 6.96575 16.0118 6.96575C13.871 6.96575 12.566 7.79288 11.7832 8.77274Z"
      fill="#000000"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.7829 8.77281C10.9818 9.77556 10.7074 10.9662 10.7074 11.6738C10.7074 12.3299 10.763 13.2414 10.8099 13.895C10.8254 14.112 10.7809 14.365 10.5914 14.5659C10.3995 14.7692 10.1385 14.8352 9.90529 14.8352C9.56858 14.8352 9.31249 14.712 9.14866 14.6332L9.12964 14.624C8.94686 14.5364 8.85077 14.4956 8.70949 14.4956C8.58097 14.4956 8.42405 14.5509 8.29963 14.6515C8.1735 14.7536 8.13694 14.8535 8.13694 14.9106C8.13694 15.027 8.17987 15.1101 8.33763 15.2122C8.52395 15.3327 8.78944 15.4233 9.13748 15.5374L9.16778 15.5474C9.4568 15.6421 9.81479 15.7593 10.0973 15.9354C10.4144 16.1331 10.7074 16.4508 10.7074 16.9402C10.7074 17.0685 10.6719 17.192 10.6386 17.2855C10.6025 17.387 10.5536 17.4942 10.4989 17.6011C10.3893 17.8153 10.241 18.0572 10.0779 18.2979C9.75451 18.7754 9.34339 19.2918 9.00168 19.6206C8.65623 19.9529 8.13672 20.3264 7.61127 20.6178C7.34664 20.7646 7.07037 20.8962 6.80396 20.9923C6.56549 21.0784 6.30848 21.1458 6.06192 21.1563C6.05578 21.1589 6.04899 21.162 6.04188 21.1656C6.03051 21.1713 6.01988 21.1775 6.01061 21.1837L6.00586 21.187C6.00679 21.1937 6.00785 21.1986 6.00874 21.2021C6.01071 21.2098 6.01305 21.2153 6.01621 21.221C6.02587 21.2385 6.04112 21.258 6.10279 21.3241L6.11897 21.3414C6.23006 21.4609 6.50385 21.616 6.93783 21.7548C7.35116 21.8869 7.83992 21.9823 8.30169 22.0261C8.53273 22.048 8.6659 22.1924 8.72226 22.2701C8.78027 22.3502 8.81345 22.4348 8.83284 22.4909C8.87035 22.5995 8.89868 22.7332 8.92103 22.8387L8.92443 22.8548C8.95494 22.9986 8.98162 23.1215 9.01643 23.2243C9.02873 23.2606 9.04009 23.2883 9.04986 23.3086C9.07189 23.3111 9.10567 23.3135 9.15461 23.3133C9.36694 23.3125 9.57952 23.2808 9.7899 23.2555C10.1265 23.2149 10.543 23.1647 10.984 23.1647C12.0068 23.1647 12.6817 23.6259 13.3336 24.0713L13.3702 24.0963C13.6115 24.2611 13.8533 24.426 14.1252 24.5867C14.8914 25.0395 15.4744 25.0362 15.9003 25.0338C15.9303 25.0336 15.9595 25.0335 15.9879 25.0335C16.0161 25.0335 16.0451 25.0336 16.075 25.0338C16.5056 25.0361 17.1081 25.0394 17.8742 24.5867C18.1461 24.426 18.3879 24.2611 18.6291 24.0963L18.6657 24.0713C19.3177 23.6259 19.9926 23.1647 21.0154 23.1647C21.4564 23.1647 21.8729 23.2149 22.2095 23.2555L22.2196 23.2567C22.4918 23.2895 22.691 23.3127 22.8448 23.3133C22.8937 23.3135 22.9275 23.3111 22.9495 23.3086C22.9593 23.2883 22.9706 23.2606 22.9829 23.2243C23.0177 23.1215 23.0444 22.9986 23.0749 22.8548L23.0783 22.8387C23.1007 22.7332 23.129 22.5995 23.1665 22.4909C23.1859 22.4347 23.2191 22.3502 23.2771 22.2701C23.3335 22.1923 23.4666 22.048 23.6977 22.0261C24.1595 21.9823 24.6482 21.8869 25.0615 21.7548C25.4955 21.616 25.7693 21.461 25.8804 21.3414L25.8966 21.3241C25.9582 21.258 25.9735 21.2385 25.9832 21.221C25.9863 21.2153 25.9887 21.2098 25.9906 21.2021C25.9915 21.1986 25.9926 21.1937 25.9935 21.187L25.9888 21.1837C25.9795 21.1775 25.9689 21.1713 25.9575 21.1656C25.9504 21.162 25.9436 21.1589 25.9374 21.1563C25.6909 21.1458 25.4339 21.0784 25.1954 20.9923C24.929 20.8962 24.6527 20.7646 24.3881 20.6178C23.8626 20.3264 23.3431 19.9529 22.9977 19.6206C22.656 19.2918 22.2449 18.7754 21.9214 18.2979C21.7584 18.0572 21.6101 17.8153 21.5004 17.6011C21.4457 17.4942 21.3969 17.387 21.3607 17.2855C21.3275 17.192 21.292 17.0685 21.292 16.9402C21.292 16.4508 21.585 16.1331 21.9021 15.9354C22.1846 15.7593 22.5426 15.6421 22.8316 15.5474L22.8619 15.5374C23.2099 15.4233 23.4754 15.3327 23.6617 15.2122C23.8195 15.1101 23.8624 15.027 23.8624 14.9106C23.8624 14.8535 23.8259 14.7536 23.6997 14.6515C23.5753 14.5509 23.4184 14.4956 23.2899 14.4956C23.1486 14.4956 23.0525 14.5364 22.8697 14.624L22.8507 14.6332C22.6869 14.712 22.4308 14.8352 22.0941 14.8352C21.8609 14.8352 21.5999 14.7692 21.408 14.5659C21.2184 14.365 21.1739 14.112 21.1895 13.895C21.2364 13.2414 21.292 12.3299 21.292 11.6738C21.292 10.9644 21.0224 9.7736 20.2272 8.77157C19.4505 7.79271 18.152 6.96582 16.0114 6.96582C13.8706 6.96582 12.5657 7.79296 11.7829 8.77281Z"
      fill="white"
    />
  </svg>
);

export function IconUpload() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 16C11.7167 16 11.4793 15.904 11.288 15.712C11.096 15.5207 11 15.2833 11 15V7.84999L9.125 9.72499C8.925 9.92499 8.69167 10.025 8.425 10.025C8.15833 10.025 7.91667 9.91665 7.7 9.69999C7.5 9.49999 7.40433 9.26232 7.413 8.98699C7.421 8.71232 7.51667 8.48332 7.7 8.29999L11.3 4.69999C11.4 4.59999 11.5083 4.52899 11.625 4.48699C11.7417 4.44565 11.8667 4.42499 12 4.42499C12.1333 4.42499 12.2583 4.44565 12.375 4.48699C12.4917 4.52899 12.6 4.59999 12.7 4.69999L16.3 8.29999C16.5 8.49999 16.5957 8.73732 16.587 9.01199C16.579 9.28732 16.4833 9.51665 16.3 9.69999C16.1 9.89999 15.8627 10.004 15.588 10.012C15.3127 10.0207 15.075 9.92499 14.875 9.72499L13 7.84999V15C13 15.2833 12.9043 15.5207 12.713 15.712C12.521 15.904 12.2833 16 12 16ZM6 20C5.45 20 4.97933 19.8043 4.588 19.413C4.196 19.021 4 18.55 4 18V16C4 15.7167 4.09567 15.479 4.287 15.287C4.479 15.0957 4.71667 15 5 15C5.28333 15 5.521 15.0957 5.713 15.287C5.90433 15.479 6 15.7167 6 16V18H18V16C18 15.7167 18.096 15.479 18.288 15.287C18.4793 15.0957 18.7167 15 19 15C19.2833 15 19.5207 15.0957 19.712 15.287C19.904 15.479 20 15.7167 20 16V18C20 18.55 19.8043 19.021 19.413 19.413C19.021 19.8043 18.55 20 18 20H6Z"
        fill="#2B59FF"
      />
    </svg>
  );
}

export function IconStorage() {
  return (
    <svg
      width="20px"
      height="20px"
      viewBox="-3.2 -3.2 38.40 38.40"
      xmlns="http://www.w3.org/2000/svg"
      fill="#000000"
    >
      <g id="SVGRepo_bgCarrier" stroke-width="0" />

      <g
        id="SVGRepo_tracerCarrier"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke="#CCCCCC"
        stroke-width="0.064"
      />

      <g id="SVGRepo_iconCarrier">
        <defs id="defs2" />
        <g id="layer1" transform="translate(-396,-436)">
          <path d="m 419,456.01367 a 1,1 0 0 0 -1,1 v 3.58594 l -0.29297,-0.29297 A 1,1 0 0 0 417,460.01367 a 1,1 0 0 0 -0.70703,0.29297 1,1 0 0 0 0,1.41406 l 2,2 a 1.0001,1.0001 0 0 0 0.0469,0.0371 1,1 0 0 0 0.0859,0.0684 1.0001,1.0001 0 0 0 0.0898,0.0566 1,1 0 0 0 0.10547,0.0508 1.0001,1.0001 0 0 0 0.10352,0.0352 1,1 0 0 0 0.10547,0.0254 1.0001,1.0001 0 0 0 0.11914,0.0137 1,1 0 0 0 0.0508,0.006 1,1 0 0 0 0.0508,-0.006 1.0001,1.0001 0 0 0 0.11914,-0.0137 1,1 0 0 0 0.10547,-0.0254 1.0001,1.0001 0 0 0 0.10352,-0.0352 1,1 0 0 0 0.10547,-0.0508 1.0001,1.0001 0 0 0 0.0898,-0.0566 1,1 0 0 0 0.0859,-0.0684 1.0001,1.0001 0 0 0 0.0469,-0.0371 l 2,-2 a 1,1 0 0 0 0,-1.41406 1,1 0 0 0 -1.41406,0 L 420,460.59961 v -3.58594 a 1,1 0 0 0 -1,-1 z" />
          <path d="m 408,437 c -2.63824,0 -5.03895,0.59351 -6.85742,1.62305 C 399.32411,439.65259 398,441.21117 398,443.0957 v 17.80469 c 0,1.88494 1.32411,3.4461 3.14258,4.47656 1.81847,1.03047 4.219,1.62305 6.85742,1.62305 2.54606,0 4.86486,-0.55269 6.65625,-1.51953 C 415.85152,466.43054 417.36127,467 419,467 c 3.85414,0 7,-3.14585 7,-7 0,-3.85414 -3.14586,-7 -7,-7 -0.33979,0 -0.67289,0.025 -1,0.0723 v -9.97657 c 0,-1.88453 -1.32411,-3.44311 -3.14258,-4.47265 C 413.03895,437.59351 410.63824,437 408,437 Z m 0,2 c 2.33231,0 4.43222,0.54865 5.87109,1.36328 1.43889,0.81464 2.12891,1.80225 2.12891,2.73242 0,0.93097 -0.69003,1.92119 -2.12891,2.73633 -1.43886,0.81515 -3.5389,1.36328 -5.87109,1.36328 -2.33219,0 -4.43223,-0.54813 -5.87109,-1.36328 C 400.69003,445.01689 400,444.02667 400,443.0957 c 0,-0.93017 0.69002,-1.91778 2.12891,-2.73242 C 403.56778,439.54865 405.66769,439 408,439 Z m -8,7.79492 c 0.35022,0.28389 0.73259,0.54508 1.14258,0.77735 1.81848,1.03019 4.21906,1.62304 6.85742,1.62304 2.63836,0 5.03894,-0.59285 6.85742,-1.62304 0.40999,-0.23227 0.79236,-0.49346 1.14258,-0.77735 v 2.23633 c 0,0.93097 -0.69003,1.91923 -2.12891,2.73437 -1.43886,0.81514 -3.5389,1.36524 -5.87109,1.36524 -2.33219,0 -4.43223,-0.5501 -5.87109,-1.36524 C 400.69003,450.95048 400,449.96222 400,449.03125 Z m 0,5.9336 c 0.35022,0.28373 0.73259,0.54507 1.14258,0.77734 1.81848,1.0302 4.21906,1.625 6.85742,1.625 2.63836,0 5.03894,-0.5948 6.85742,-1.625 0.40999,-0.23227 0.79236,-0.49361 1.14258,-0.77734 v 0.94921 c -1.90408,0.90926 -3.33657,2.65527 -3.82031,4.75586 -1.21133,0.39535 -2.64498,0.63087 -4.17969,0.63086 -2.33226,0 -4.43224,-0.54836 -5.87109,-1.36328 C 400.69004,456.88625 400,455.89776 400,454.9668 Z M 419,455 c 2.77327,0 5,2.22674 5,5 0,2.77327 -2.22673,5 -5,5 -2.77327,0 -5,-2.22673 -5,-5 0,-0.21391 0.0133,-0.42422 0.0391,-0.63086 a 0.99999499,0.99999499 0 0 0 0.0176,-0.13281 c 0.27125,-1.78885 1.48397,-3.25773 3.11914,-3.89453 a 0.99999499,0.99999499 0 0 0 0.28906,-0.10352 C 417.94782,455.0841 418.46408,455 419,455 Z m -19,3.66406 c 0.35022,0.28372 0.73259,0.54514 1.14258,0.77735 1.81849,1.02993 4.21913,1.62305 6.85742,1.62304 1.43128,0 2.78941,-0.17768 4.02539,-0.50195 0.10036,1.24866 0.52985,2.40692 1.20313,3.38672 C 411.83846,464.58387 410.01096,465 408,465 c -2.33213,0 -4.43222,-0.54791 -5.87109,-1.36328 C 400.69002,462.82136 400,461.83136 400,460.90039 Z" />
        </g>
      </g>
    </svg>
  );
}

export function IconSubscription() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      clipRule="evenodd"
      width={20}
      height={20}
      imageRendering="optimizeQuality"
      shapeRendering="geometricPrecision"
      textRendering="geometricPrecision"
      viewBox="0 0 512 496.61"
    >
      <path d="M42.09 42.35h38.82v51.8c0 14.4 6.7 27.13 17.51 35.98 9.13 7.49 21.28 12.13 34.26 12.13 12.99 0 25.14-4.64 34.28-12.13 10.8-8.85 17.5-21.58 17.5-35.98v-51.8h78.39v51.8c0 14.4 6.69 27.13 17.5 35.98 9.13 7.49 21.29 12.13 34.27 12.13 12.98 0 25.14-4.64 34.27-12.13 10.81-8.85 17.51-21.58 17.51-35.98v-51.8h40.52c11.56 0 22.08 4.75 29.72 12.38 7.64 7.61 12.38 18.14 12.38 29.72v144.24a157.45 157.45 0 00-17.98-5.73v-58.75H17.98v244.83c0 18.19 14.89 33.1 33.1 33.1h201.39a154.57 154.57 0 0010.28 17.97H42.09c-11.54 0-22.06-4.73-29.7-12.36C4.74 440.08 0 429.57 0 418.03V84.44c0-11.56 4.74-22.07 12.36-29.7 7.65-7.65 18.18-12.39 29.73-12.39zm324.19 430.69c5.37 1.43 8.56 6.95 7.13 12.32-1.44 5.37-6.96 8.56-12.32 7.13a120.88 120.88 0 01-13.74-4.57c-25.72-10.29-46.32-28.83-59.5-51.65-15.46-26.74-20.7-59.38-12.09-91.54 8.61-32.15 29.47-57.78 56.22-73.23 26.73-15.46 59.38-20.71 91.54-12.08 11.24 3.01 21.69 7.51 31.18 13.23a120.08 120.08 0 0121 16.1l-.55-5.33c-.56-5.51 3.44-10.44 8.95-11 5.51-.56 10.43 3.45 11 8.96l2.88 27.82c.1 1.02.05 2.03-.15 2.99-.42 4.99-4.53 8.99-9.66 9.15l-27.95.99c-5.52.17-10.15-4.18-10.32-9.7-.17-5.53 4.17-10.15 9.69-10.32l1.12-.04c-4.98-4.63-10.47-8.78-16.4-12.37-7.92-4.78-16.63-8.53-25.99-11.04-26.82-7.18-54.01-2.82-76.26 10.03-22.29 12.84-39.66 34.21-46.84 61.03-7.19 26.82-2.84 54.01 10.02 76.28 6.39 11.09 14.89 20.97 25.13 28.97 10.19 7.98 23.41 14.54 35.91 17.87zm21.37-160.44h20.09l-.48 12.66c8.45.53 15.83 1.37 22.16 2.54l-4.59 24.51H401.1c-3.69 0-6.15.58-7.36 1.74-1.21 1.16-1.87 3.38-1.98 6.64l9.97 1.11c12.13 1.37 20.49 4.48 25.08 9.34 4.58 4.85 6.88 11.12 6.88 18.82 0 7.7-.8 13.85-2.38 18.43-1.58 4.58-3.85 8.09-6.8 10.52-5.38 4.11-12.44 6.49-21.19 7.12l-.48 15.97h-20.41l.64-15.97c-10.02-.73-18.51-2.01-25.47-3.8l4.58-25.15c8.76 2.32 17.93 3.48 27.53 3.48 4.01 0 7.75-.21 11.23-.63v-6.65l-9.81-1.11c-12.66-1.26-21.09-4.95-25.31-11.07-3.69-5.37-5.53-12.39-5.53-21.04 0-11.38 2.34-19.66 7.04-24.83 4.69-5.17 11.3-8.34 19.85-9.49l.47-13.14zm10.79 163.84c-13.97 1.17-11.44 21.17 1.08 20.13 7.13-.34 14.89-1.52 21.82-3.25 12.86-3.22 8.01-22.79-4.91-19.55-5.95 1.45-11.88 2.3-17.99 2.67zm51.19-17.66c-10.86 7.61.68 24.13 11.55 16.52 5.89-4.05 11.85-9.12 16.82-14.25 9.13-9.13-4.81-23.69-14.47-14.04-4 4.19-9.12 8.49-13.9 11.77zm34.42-42.03c-5.4 11.87 12.83 20.48 18.43 8.16 3.08-6.97 5.14-13.44 7.06-20.79 3.17-12.65-16.32-17.82-19.6-4.69-1.74 6.23-3.25 11.36-5.89 17.32zm7.88-53.71c2.11 12.71 20.07 10.98 20.07-1.51l-.08-1.09c-1-7.42-2.51-14.26-4.77-21.42-4.29-12.87-23.3-6.18-19.19 6.16a105.17 105.17 0 013.97 17.86zm-294.54-43.78h49.42c-6.41 17.06-9.94 35.54-9.94 54.84 0 3.59.14 7.16.38 10.69h-39.86c-4.21 0-7.69-3.45-7.69-7.67v-50.18c0-4.22 3.46-7.68 7.69-7.68zm0-106.69h60.3c4.23 0 7.68 3.47 7.68 7.68v50.17c0 4.2-3.47 7.68-7.68 7.68h-60.3c-4.21 0-7.69-3.46-7.69-7.68v-50.17c0-4.23 3.46-7.68 7.69-7.68zm-121.63 0h60.3c4.23 0 7.69 3.47 7.69 7.68v50.17c0 4.2-3.48 7.68-7.69 7.68h-60.3c-4.21 0-7.68-3.46-7.68-7.68v-50.17c0-4.23 3.46-7.68 7.68-7.68zm243.25 0h60.31c3.57 0 6.58 2.48 7.44 5.78-27.59 1.04-53.33 9.25-75.43 22.81v-20.91c0-4.23 3.46-7.68 7.68-7.68zM75.76 319.26h60.3c4.23 0 7.69 3.48 7.69 7.68v50.18c0 4.2-3.48 7.67-7.69 7.67h-60.3c-4.21 0-7.68-3.45-7.68-7.67v-50.18c0-4.22 3.46-7.68 7.68-7.68zM294.3 16.66C294.3 7.47 303.39 0 314.62 0c11.24 0 20.33 7.47 20.33 16.66v77.49c0 9.19-9.09 16.66-20.33 16.66-11.23 0-20.32-7.47-20.32-16.66V16.66zm-181.94 0c0-9.19 9.09-16.66 20.32-16.66 11.24 0 20.33 7.47 20.33 16.66v77.49c0 9.19-9.09 16.66-20.33 16.66-11.23 0-20.32-7.47-20.32-16.66V16.66z" />
    </svg>
  );
}

export function IconInformation() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M9.375 9.375L9.40917 9.35833C9.51602 9.30495 9.63594 9.2833 9.75472 9.29596C9.8735 9.30862 9.98616 9.35505 10.0794 9.42976C10.1726 9.50446 10.2424 9.60432 10.2806 9.71749C10.3189 9.83066 10.3238 9.95242 10.295 10.0683L9.705 12.4317C9.67595 12.5476 9.68078 12.6695 9.71891 12.7828C9.75704 12.8961 9.82687 12.9961 9.92011 13.071C10.0134 13.1458 10.1261 13.1923 10.245 13.205C10.3639 13.2177 10.4839 13.196 10.5908 13.1425L10.625 13.125M17.5 10C17.5 10.9849 17.306 11.9602 16.9291 12.8701C16.5522 13.7801 15.9997 14.6069 15.3033 15.3033C14.6069 15.9997 13.7801 16.5522 12.8701 16.9291C11.9602 17.306 10.9849 17.5 10 17.5C9.01509 17.5 8.03982 17.306 7.12987 16.9291C6.21993 16.5522 5.39314 15.9997 4.6967 15.3033C4.00026 14.6069 3.44781 13.7801 3.0709 12.8701C2.69399 11.9602 2.5 10.9849 2.5 10C2.5 8.01088 3.29018 6.10322 4.6967 4.6967C6.10322 3.29018 8.01088 2.5 10 2.5C11.9891 2.5 13.8968 3.29018 15.3033 4.6967C16.7098 6.10322 17.5 8.01088 17.5 10ZM10 6.875H10.0067V6.88167H10V6.875Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function IconTablePaginateNext() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.9101 20.67C8.7201 20.67 8.5301 20.6 8.3801 20.45C8.0901 20.16 8.0901 19.68 8.3801 19.39L14.9001 12.87C15.3801 12.39 15.3801 11.61 14.9001 11.13L8.3801 4.60999C8.0901 4.31999 8.0901 3.83999 8.3801 3.54999C8.6701 3.25999 9.1501 3.25999 9.4401 3.54999L15.9601 10.07C16.4701 10.58 16.7601 11.27 16.7601 12C16.7601 12.73 16.4801 13.42 15.9601 13.93L9.4401 20.45C9.2901 20.59 9.1001 20.67 8.9101 20.67Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function IconTablePaginatePrev() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15 20.67C14.81 20.67 14.62 20.6 14.47 20.45L7.95003 13.93C6.89003 12.87 6.89003 11.13 7.95003 10.07L14.47 3.54999C14.76 3.25999 15.24 3.25999 15.53 3.54999C15.82 3.83999 15.82 4.31999 15.53 4.60999L9.01003 11.13C8.53003 11.61 8.53003 12.39 9.01003 12.87L15.53 19.39C15.82 19.68 15.82 20.16 15.53 20.45C15.38 20.59 15.19 20.67 15 20.67Z"
        fill="currentColor"
      />
    </svg>
  );
}
